import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginSSO from './login-sso';
import useAuth from 'state/auth/hooks/useAuth';
import routeConfig from 'routes/config';

const Login = (): JSX.Element => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  // for redirection
  useEffect(() => {
    if (auth.loggedIn) {
      navigate(
        `${routeConfig.ROOT}${routeConfig.STORES.layout}/${routeConfig.STORES.LIST.path}`
      );
    }
  }, [auth.loggedIn]);

  return (
    <div className="w-full flex flex-col justify-center mt-8 md:mt-12 px-0">
      <h4
        className="text-2xl md:text-3xl font-normal text-gray-900 mb-3"
        id="SignInText"
      >
        Continue to Sign in
      </h4>

      <LoginSSO />
    </div>
  );
};

export default Login;
